// extracted by mini-css-extract-plugin
module.exports = {"root":"Data_root__2YAZ_","chartSection":"Data_chartSection__2tWPs","chartContainer":"Data_chartContainer__25Kqg"};